import styled from "styled-components";

const Container = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  gap: 0;
`;

const Image = styled.div<{ blockMoreInfo?: boolean }>`
  position: relative;
  min-width: 50px;
  height: 50px;
  border-radius: 50%;
  cursor: ${(props) => (props.blockMoreInfo ? "" : "pointer")};
  border: 3px solid ${({ theme }) => theme.colors.navBarIcons};
  overflow: hidden;

  > :first-child {
    width: 100%;
    height: 100%;
    path {
      transform: translate(-2px, 0px) scale(1.2);
      color: ${({ theme }) => theme.colors.navBarIcons};
    }
  }
`;

const Badge = styled.div`
    position: absolute;
    background-color: red;
    width: unset;
    height: unset;
    padding: 3px;
    border-radius: 5px;
    font-size: 9px;
    top: -8px;
    z-index: 999;
    color: white;
    font-weight: bold;
`;

export { Container, Image, Badge };